"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAttributeDisplayFormMetadataObject = exports.attributeDisplayFormAttributeRef = exports.attributeDisplayFormTitle = exports.attributeDisplayFormRef = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var types_1 = require("../types");
/**
 * Gets the attribute display form's ObjRef
 * @param displayForm - attribute display form to work with
 * @returns ObjRef of the attribute display form
 * @public
 */
function attributeDisplayFormRef(displayForm) {
    ts_invariant_1.default(displayForm, "displayForm must be specified");
    return displayForm.ref;
}
exports.attributeDisplayFormRef = attributeDisplayFormRef;
/**
 * Gets the attribute display form's title.
 * @param displayForm - attribute display form to work with
 * @returns title of the attribute display form
 * @public
 */
function attributeDisplayFormTitle(displayForm) {
    ts_invariant_1.default(displayForm, "displayForm must be specified");
    return displayForm.title;
}
exports.attributeDisplayFormTitle = attributeDisplayFormTitle;
/**
 * Gets ObjRef of the attribute the display form is a form of.
 *
 * @param displayForm - attribute display form to work with
 * @returns display form ObjRef
 * @public
 */
function attributeDisplayFormAttributeRef(displayForm) {
    ts_invariant_1.default(displayForm, "displayForm must be specified");
    return displayForm.attribute;
}
exports.attributeDisplayFormAttributeRef = attributeDisplayFormAttributeRef;
/**
 * Tests whether the provided object is of type {@link IAttributeDisplayFormMetadataObject}.
 *
 * @param obj - object to test
 * @public
 */
function isAttributeDisplayFormMetadataObject(obj) {
    return types_1.isMetadataObject(obj) && obj.type === "displayForm";
}
exports.isAttributeDisplayFormMetadataObject = isAttributeDisplayFormMetadataObject;
//# sourceMappingURL=index.js.map